




























import {Component, Mixins, Prop, Vue} from 'vue-property-decorator'
import {$, Collection, ID, PageCollection, sleep} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import Carga from '@/model/resource/Carga'
import CargaCollection from '@/model/collection/CargaCollection'
import {MixinFilter} from '@/components/mixins/MixinFilter'

const metaInfo = () => ({
  title: $.t('view.manage.deliveryGetCteListView.title'),
})

@Component({})
export default class DeliveryGetCteListView extends Mixins(MixinFilter) {
  @Prop({type: [String, Number]}) id!: ID
  @Prop({type: String, default: null}) hash!: string | null

  AppConfig = AppConfig

  collection = new CargaCollection({}, `/user/carga/cte/${this.id}`)

  async created() {

      const hash = this.hash ? encodeURIComponent(this.hash) : undefined
      const idStatus = this.$route.query.idStatus
      const params = {hash, idStatus}
      this.collection.filter = params
      $.await.done('query')
  }
}
